import '@fortawesome/fontawesome-free/css/all.css'
import './styles/style.scss'

import carrier from './images/carrier-logo.svg'

import { runApp } from '@/app-loader'

runApp({
  name: 'Claro Controle - Pagamento PIX',
  images: {
    carrier
  }
})
